import type { I18nFn } from 'i18n/types/I18nFn';

export function US_STATES_ONLY(i18n: I18nFn) {
  return [
    {
      id: 'AL',
      name: i18n('Alabama'),
    },
    {
      id: 'AK',
      name: i18n('Alaska'),
    },
    {
      id: 'AZ',
      name: i18n('Arizona'),
    },
    {
      id: 'AR',
      name: i18n('Arkansas'),
    },
    {
      id: 'CA',
      name: i18n('California'),
    },
    {
      id: 'CO',
      name: i18n('Colorado'),
    },
    {
      id: 'CT',
      name: i18n('Connecticut'),
    },
    {
      id: 'DE',
      name: i18n('Delaware'),
    },
    {
      id: 'DC',
      name: i18n('District of Columbia'),
    },
    {
      id: 'FL',
      name: i18n('Florida'),
    },
    {
      id: 'GA',
      name: i18n('Georgia'),
    },
    {
      id: 'HI',
      name: i18n('Hawaii'),
    },
    {
      id: 'ID',
      name: i18n('Idaho'),
    },
    {
      id: 'IL',
      name: i18n('Illinois'),
    },
    {
      id: 'IN',
      name: i18n('Indiana'),
    },
    {
      id: 'IA',
      name: i18n('Iowa'),
    },
    {
      id: 'KS',
      name: i18n('Kansas'),
    },
    {
      id: 'KY',
      name: i18n('Kentucky'),
    },
    {
      id: 'LA',
      name: i18n('Louisiana'),
    },
    {
      id: 'ME',
      name: i18n('Maine'),
    },
    {
      id: 'MD',
      name: i18n('Maryland'),
    },
    {
      id: 'MA',
      name: i18n('Massachusetts'),
    },
    {
      id: 'MI',
      name: i18n('Michigan'),
    },
    {
      id: 'MN',
      name: i18n('Minnesota'),
    },
    {
      id: 'MS',
      name: i18n('Mississippi'),
    },
    {
      id: 'MO',
      name: i18n('Missouri'),
    },
    {
      id: 'MT',
      name: i18n('Montana'),
    },
    {
      id: 'NE',
      name: i18n('Nebraska'),
    },
    {
      id: 'NV',
      name: i18n('Nevada'),
    },
    {
      id: 'NH',
      name: i18n('New Hampshire'),
    },
    {
      id: 'NJ',
      name: i18n('New Jersey'),
    },
    {
      id: 'NM',
      name: i18n('New Mexico'),
    },
    {
      id: 'NY',
      name: i18n('New York'),
    },
    {
      id: 'NC',
      name: i18n('North Carolina'),
    },
    {
      id: 'ND',
      name: i18n('North Dakota'),
    },
    {
      id: 'OH',
      name: i18n('Ohio'),
    },
    {
      id: 'OK',
      name: i18n('Oklahoma'),
    },
    {
      id: 'OR',
      name: i18n('Oregon'),
    },
    {
      id: 'PA',
      name: i18n('Pennsylvania'),
    },
    {
      id: 'RI',
      name: i18n('Rhode Island'),
    },
    {
      id: 'SC',
      name: i18n('South Carolina'),
    },
    {
      id: 'SD',
      name: i18n('South Dakota'),
    },
    {
      id: 'TN',
      name: i18n('Tennessee'),
    },
    {
      id: 'TX',
      name: i18n('Texas'),
    },
    {
      id: 'UT',
      name: i18n('Utah'),
    },
    {
      id: 'VT',
      name: i18n('Vermont'),
    },
    {
      id: 'VA',
      name: i18n('Virginia'),
    },
    {
      id: 'WA',
      name: i18n('Washington'),
    },
    {
      id: 'WV',
      name: i18n('West Virginia'),
    },
    {
      id: 'WI',
      name: i18n('Wisconsin'),
    },
    {
      id: 'WY',
      name: i18n('Wyoming'),
    },
  ];
}

export function US_STATES_TERRITORIES(i18n: I18nFn) {
  return [
    {
      id: 'AS',
      name: i18n('American Samoa'),
    },
    {
      id: 'FM',
      name: i18n('Federated States of Micronesia'),
    },
    {
      id: 'GU',
      name: i18n('Guam'),
    },
    {
      id: 'MH',
      name: i18n('Marshall Islands'),
    },
    {
      id: 'MP',
      name: i18n('Northern Mariana Islands'),
    },
    {
      id: 'PW',
      name: i18n('Palau'),
    },
    {
      id: 'PR',
      name: i18n('Puerto Rico'),
    },
    {
      id: 'VI',
      name: i18n('Virgin Islands'),
    },
  ];
}

export function US_STATES(i18n: I18nFn) {
  return [...US_STATES_ONLY(i18n), ...US_STATES_TERRITORIES(i18n)];
}
